<div mat-dialog-title>
  <mat-icon
    *ngIf="!hideCloseButtonIcon"
    mat-icon-button
    color="primary"
    class="close-icon"
    [class.disabled-icon]="isLoading"
    aria-label="close"
    (click)="closeDialog()"
  >
    close
  </mat-icon>

  <h2 *ngIf="title" [innerHTML]="title"></h2>

  <ng-container *ngIf="subtitle">
    <lib-spacer [height]="10"></lib-spacer>

    <div class="subtitle" [innerHTML]="subtitle"></div>
  </ng-container>

  <ng-content select="[header]"></ng-content>

  <mat-progress-bar
    *ngIf="isLoading && hideButtonContainer"
    mode="indeterminate"
  ></mat-progress-bar>
</div>

<mat-dialog-content
  [id]="dialogContentId"
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="1"
  (scrolled)="scrolledToTheEnd.emit()"
>
  <ng-content select="[body]"></ng-content>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!hideButtonContainer">
  <div
    class="actions-container"
    [class.actions-container-responsive]="
      displayActionContainerAsColumnOnMobile
    "
  >
    <ng-content select="[action]"></ng-content>
  </div>

  <lib-spacer [height]="10"></lib-spacer>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</mat-dialog-actions>
